/**
 * Created by lzy 19-11-03
 * 百家号新建稿件
 */
'use strict';
angular.module('editBaijiahaoToBeCompiledVideoModule', []).controller('editingCenterBaijiahaoVideoCtrl', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'iWoService',
    'globleParamsSet',
    'editPictureService',
    'editCenUploadVideoForXjService',
    'baijiahaoService',
    'editingMediatype',
    'newMediaService',
    'baijiaConst',
    'editIsLock',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        iWoService,
        globleParamsSet,
        editPictureService,
        editCenUploadVideoForXjService,
        baijiahaoService,
        editingMediatype,
        newMediaService,
        baijiaConst,
        editIsLock,
        messagePublishService
    ) {
        initStatus();
        initData();
        baijiahaoService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                support: {
                    content: '',
                },
                baijiahaoFormError: [],
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                progressss: 0,
                topAttachFilePicSize: '16,9',
                isFusionEditor: $state.current.name == 'fusionvideo', // 是否来自融合编辑器
                isEditDraft: !!$state.params.baijiahaoarticleid,
                baijiahaoarticleid: $state.params.baijiahaoarticleid,
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                mediaType: editingMediatype.baijiahao,
            };
            $scope.data = {
                trench: baijiaConst.listenStroageKey,
                scaleImgSize: globleParamsSet.scaleImgSize(),
                version: [], // 流程展示数据
                copyVersion: []
            };
            $scope.uploader = {
                example: '',
                progress: 0,
                fastVideoTimer: '',
                canNotPlay: false,
                fastVideoInfo: {}, // 视频快编信息
                uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.editFlag = {
                media: 'baijiahao', 
                docType: 'video',
            };
        }

        /** **************************适应融合编辑器切换渠道开始**************************/
        /**
         * [initData description]初始化数据
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]传入的方法
         * @return  {[promise]}                   [return description]promise
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if ($state.params.baijiahaoarticleid) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/
        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                initArrayBtn();
                ($state.params.baijiahaoarticleid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData description]初始化新稿件
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                serviceid: 'mlf_baijiahao',
                methodName: 'save',
                DOCTYPEID: 7,
                DOCTYPE: 7,
                BAIJIAHAOARTICLEID: $state.params.baijiahaoarticleid || 0,
                // BAIJIAHAOACCOUNTID: $state.params.baijiahaoaccount,
                ACCOUNTID: $state.params.baijiahaoaccount,
                TITLE: '',
                VIDEOREL: [],
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                POSTER: [],
                POSTERURL: [],
                POSTERDESC: [],
                ORIGINAL: 0,
                SPECIALDOC: 0,
                ISNOPAYMENT: '1'
            };
            loadDirective();
            initDocgenre();
            // 融合编辑器下转码list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initEditData description]初始化编辑稿件
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]
         * @return  {[promise]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_baijiahao',
                methodName: 'getBaiJiaHaoArticle',
                baiJiaHaoArticleId: $state.params.baijiahaoarticleid,
            };
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusionbaijia',
                    methodname: 'getBaiJiaVirtualDoc',
                    SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                $scope.list.TOPATTACHFILE = [];
                $scope.list.serviceid = 'mlf_baijiahao';
                $scope.list.methodName = 'save';
                // $scope.data.specialDoc = $scope.list.SPECIALDOC;
                $scope.status.videoStatus = true;
                if (!$scope.list.POSTER) {
                    $scope.list.POSTER = [];
                    $scope.list.POSTERURL = [];
                }
                loadDirective();
                initDocgenre($scope.list);
                showVersion();
                // 融合编辑下转码list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                defer.resolve();
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.baijiahaoarticleid);
            return defer.promise;
        }

        /**
         * [initDocgenre description]
         * @param   {[type]}  obj  [obj description]
         * @return  {[type]}       [return description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.data.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = obj ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
            });
        }

        /**
         * [getAttachFileData description]
         *
         * @param   {[type]}  picData  [picData description]
         * @param   {[type]}  picType  [picType description]
         *
         * @return  {[type]}           [return description]
         */
        function getAttachFileData(picData, picType) {
            return [
                {
                    APPFILE: picData.imgName || picData.APPFILE,
                    APPDESC: picData.imgName || picData.APPDESC,
                    PERPICURL: picData.imgSrc || picData.PERPICURL,
                    TOPPIC: picType,
                },
            ];
        }

        /**
         * [getPicDataInit description]
         *
         * @param   {[type]}  picData  [picData description]
         *
         * @return  {[type]}           [return description]
         */
        function getPicDataInit(picData) {
            if ($scope.list.TOPATTACHFILE.length === 0) {
                $scope.list.TOPATTACHFILE = getAttachFileData(picData, '1');
            }
        }

        /**
         * [getPropagandaReview description]
         *
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [picCallbackData description] 点击获取封面图的回调
         * @return {[type]} [description]
         */
        $scope.picCallbackData = function () {
            var picresize;
            if ($scope.list.TOPATTACHFILE.length === 1) {
                modalDialog.alertType('列表图已填充满', '', 'warning', false);
                return;
            }
            if ($scope.list.TOPATTACHFILE.length === 0) {
                picresize = $scope.status.topAttachFilePicSize;
            }
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(function (src) {
                    getPicDataInit(src);
                });
            };
        };

        /**
         * [loadDirective description]动态加载指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var videoUpload = '<div trs-upload-for-xj-video-draft list="list" storage-type="baijiahao" metadata="baijiahaoarticleid"></div>';
            videoUpload = $compile(videoUpload)($scope);
            $element.find('videocon').append(videoUpload);
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="bjhVideoForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        }

        /* 稿件操作开始*/
        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            editCenUploadVideoForXjService.exampleVideoBeforeSave($scope).then(() => {
                saveList(true).then(
                    function () {
                        storageListenerService.addListenerToBaijiahao('save');
                        $scope.status.isEditDraft = true;
                        // $state.params = angular.copy($state.params);
                        $state.transitionTo($state.current, $state.params, {
                            reload: false,
                        });
                        // 保存
                        showVersion();
                        if (!$scope.status.isFusionEditor) {
                            $timeout(function () {
                                modalDialog.saveModel('保存成功', '', 'success');
                            }, 500);
                        }
                        defer.resolve();
                    },
                    function (msg) {
                        modalDialog.alertType('保存失败', '', 'warning', false);
                        defer.reject(msg);
                    }
                );
            }, () => {
                defer.reject({
                    plat: '百家号'
                });
            });
            return defer.promise;
        };

        /**
         * [saveList description]切换时保存list数据
         *
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
         *
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            // 转码发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                $scope.list.serviceid = 'mlf_fusionbaijia';
                $scope.list.methodName = 'saveBaiJiaVirtualDoc';
                $scope.list.SourceDocId = $scope.data.sourceDocId || $state.params.baijiahaoarticleid;
                $scope.list.FusionBaiJiaId = $state.params.baijiahaoarticleid || '0';
            }
            $scope.bjhVideoForm.$pending = {};
            $validation
                .validate($scope.bjhVideoForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        true,
                        function () {
                            // if (!$scope.extrasCheckTheFileSuccess()) {
                            //     return;
                            // }
                            var list = angular.copy($scope.list);
                            if (!$scope.list.POSTER[0]) {
                                modalDialog.alertType('保存失败', '百家号视频稿件必须上传一张封面图', 'warning', false);
                                return;
                            }
                            list.ORIGINALTYPE = $scope.data.originType;
                            list.SPECIALDOC = $scope.data.specialDoc;
                            list.BAIJIAHAOARTICLEID = $state.params.baijiahaoarticleid || '0';
                            list = jsonArrayToStringService.jsonArrayToString(list);
                            $scope.bjhVideoForm.$setPristine();
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                $state.params.baijiahaoarticleid = $scope.list.baijiahaoarticleid = data.METADATAID.replace(/\"/g, ''); // 后台返回的是字符串，需要转成数字类型
                                beforeonload.refresh($scope);
                                //  稿件加锁
                                if (flag) {
                                    editIsLock.lockDraft($state.params.baijiahaoarticleid);
                                }
                                editCenUploadVideoForXjService.clearDraftVideoInfo('baijiahao', 'baijiahaoarticleid');
                                defer.resolve();
                            });
                        },
                        function () {
                            defer.reject();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.bjhVideoForm, $element, $scope);
                    defer.reject({
                        plat: '百家号'
                    });
                });
            return defer.promise;
        }

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            baijiahaoService.initEditerBtn($state.params.baijiahaoplatform, $state.params.baijiahaoaccount).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /**
         * [baijiahaoTrial description]送审操作
         * @return {[type]} [description]
         */
        $scope.baijiahaoTrial = function () {
            newMediaService.trial($scope, baijiaConst.trial).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend({
                        baiJiaHaoArticleIds: $state.params.baijiahaoarticleid, accountId: $state.params.baijiahaoaccount,
                        opinion: opinion
                    }, baijiaConst.trial);
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };

        /*
         *撤稿操作
         */
        $scope.baijiahaoKill = function () {
            newMediaService.rejection($scope, baijiaConst.drawNews).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend(
                        {
                            baiJiaHaoArticleIds: $state.params.baijiahaoarticleid,
                            accountId: $state.params.account,
                            opinion: opinion
                        },
                        baijiaConst.drawNews
                    );
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };
        
        /**
         * [baijiahaoSign description]签发操作
         * @return {[type]} [description]
         */
        $scope.baijiahaoSign = function () {
            $scope.loadingPromise = newMediaService.sign($scope, baijiaConst.sign).then(() => {
                saveList().then(() => {
                    let signParams = angular.extend({
                        baiJiaHaoArticleId: $state.params.baijiahaoarticleid,
                        accountId: $state.params.baijiahaoaccount,
                    }, baijiaConst.sign);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        };


        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.bjhVideoForm.$error) {
                errorArray.push(error);
            }
            $scope.status.videoFormError = $scope.status.videoFormError == undefined ? [] : $scope.status.videoFormError;
            if ($scope.status.videoFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.videoFormError = errorArray;
            }
            return $scope.status.videoFormError; // 返回
        };

        /**
         * [deleteUploaderImg description] 删除上传后的图片
         * @return  {[type]}  [return description]
         */
        $scope.deleteUploaderImg = function () {
            $scope.list.POSTER.splice(0, 1);
        };
        // 裁剪完图片后压缩
        $scope.scaleImg = function (src) {
            var params = {
                FILENAME: src.imgName,
                FOLDEREXT: 'W0',
                SCALEHEIGHT: $scope.data.scaleImgSize.scaleHeight,
                SCALEWIDTH: $scope.data.scaleImgSize.scaleWidth,
                methodname: 'scaleImage',
                serviceid: 'mlf_image',
            };
            trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function (data) {
                $scope.list.POSTER[0] = data.FN;
                $scope.list.POSTERURL[0] = '/wcm/file/read_image.jsp?FileName=' + data.FN;
            });
        };

        /**
         * [revise description]稿件修订
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function (data) {
                    var params = {
                        MediaType: $scope.status.mediaType,
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**
         * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
         * @return  {[type]}  [return description]
         */
        function showVersion() {
            if ($scope.status.isFusionEditor) {
                getFusionVersion();
            } else {
                getVersion();
                getPropagandaReview();
            }
        }

        /**
         * [getVersion description] 获取流程记录
         * @return  {[type]}  [return description]
         */
        function getVersion() {
            newMediaService.getVersion($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.records = data;
            });
        }

        /**
         * [getVersion description] 获取融合编辑流程记录
         * @return {[type]} [description]
         */
        function getFusionVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime(
                $scope.data.sourceDocId || $state.params.iwometadataid,
                $scope.page,
                $scope.data.copyVersion
            ).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
                deffer.resolve();
            },
            function () {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getFusionVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            newMediaService.openPersonalVersionTime($state.params.iwometadataid, item);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function() {
            baijiahaoService.baijiahaoUnlock($scope.bjhVideoForm, $scope.list, saveList, $state.params.baijiahaoarticleid);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     if ($state.params.baijiahaoarticleid) {
            //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.baijiahaoarticleid }));
            //     }
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'baijiahao', saveLocal: false});
        }
    },
]);
